import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { FrontendErrorNotifierService } from './frontend-error-notifier.service';

@Injectable()
export class FrontendGlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector, private zone: NgZone) {}

  handleError(error: any): void {
    const normalized = this.normalizeError(error);
    if (this.isNonBlockingDomReconciliationError(normalized.userMessage, normalized.detail)) {
      // Error conocido de reconciliación DOM entre Angular y librerías que
      // manipulan nodos externos (DataTables/ng-bootstrap). No bloquea la
      // operación del usuario y no debe abrir alerta global.
      console.warn('non_blocking_dom_reconciliation_error_suppressed', error);
      return;
    }

    // Mantiene el error en consola para depuración.
    // El modal evita que el usuario quede sin feedback.
    console.error(error);

    const notifier = this.injector.get(FrontendErrorNotifierService);

    this.zone.run(() => {
      notifier.showError({
        title: 'Ocurrió un error en la pantalla',
        userMessage: normalized.userMessage,
        subtitle: 'La pantalla encontró un error no controlado. Copie el detalle técnico si necesita reportarlo.',
        detail: normalized.detail,
      });
    });
  }

  private normalizeError(error: any): { userMessage: string; detail: string } {
    const original = error?.rejection || error?.ngOriginalError || error;
    const message = original?.message || error?.message || String(original || error || 'Error desconocido');
    const stack = original?.stack || error?.stack || '';
    const fullText = this.collectErrorText(error);

    return {
      userMessage: message,
      detail: [message, stack, fullText]
        .filter((part, index, parts) => part && parts.indexOf(part) === index)
        .join('\n\n') || message,
    };
  }

  private isNonBlockingDomReconciliationError(message: string, detail: string): boolean {
    const text = `${message || ''}\n${detail || ''}`.toLowerCase();
    return (
      text.includes('insertbefore') &&
      (
        text.includes('not a child of this node') ||
        text.includes('the node before which the new node is to be inserted') ||
        text.includes('notfounderror')
      )
    );
  }

  private collectErrorText(error: any, depth = 0): string {
    if (!error || depth > 4) {
      return '';
    }

    if (typeof error === 'string') {
      return error;
    }

    const parts = [
      error.name,
      error.message,
      error.stack,
      error.toString && error.toString !== Object.prototype.toString ? error.toString() : '',
      this.collectErrorText(error.rejection, depth + 1),
      this.collectErrorText(error.ngOriginalError, depth + 1),
      this.collectErrorText(error.error, depth + 1),
      this.collectErrorText(error.reason, depth + 1),
    ];

    return parts.filter(Boolean).join('\n');
  }
}
